import {
  DetailsListLayoutMode,
  DetailsRow,
  Dropdown,
  Fabric,
  IColumn,
  IDetailsListProps,
  IDetailsRowStyles,
  IDropdownOption,
  IListProps,
  PrimaryButton,
  SelectionMode,
  ShimmeredDetailsList,
  Stack,
  Text,
} from "@fluentui/react";
import { stat } from "fs";
import * as React from "react";
import {
  getCustomerTicketDetails,
  getCustomerTicketDetailsExcel,
} from "../../../services/customers/CustomerService";
import { ICustomers, ITicketCountVM } from "../../../vm";
import { childrenGap } from "../../common/Constants";
import moment from "moment";
import NoDataTile from "../../common/NoDataTile";

export const TYPE_DROPDOWN: IDropdownOption[] = [
  { key: "access-permission", text: "Access Request" },
  { key: "material-movement", text: "Material Movement" },
  // { key: "others", text: "Others" },
];

export const COMPLAINT_TYPE_DROPDOWN: IDropdownOption[] = [
  { key: "case-ticket", text: "Incident (Complaint)" },
  { key: "service-complaint", text: "Service Complaint" },
  { key: "service-request", text: "Service Request" },
];

const shimmeredDetailsListProps: IListProps = {
  renderedWindowsAhead: 0,
  renderedWindowsBehind: 0,
};

export interface TicketDetailsProps {
  data: ITicketCountVM;
  customerId: string;
  startDate: Date | string;
  endDate: Date | string;
  customer: any;
  url: string;
}

const TicketDetails: React.FC<TicketDetailsProps> = ({
  data,
  customerId,
  endDate,
  startDate,
  customer,
  url,
}) => {
  const [state, setState] = React.useState({
    isLoading: false,
    search: {
      customerId: customerId,
      datacenterId: data?.datacenterId,
      type:
        // url === "service-tickets"
        url === "access-permission-and-material-movement"
          ? "access-permission"
          : url === "complaints-and-other-requests"
            // : url === "incidents"
            ? "case-ticket"
            : "remote-hand-services",
      endDate,
      startDate,
    },
    ticketDetails: [],
  } as { isLoading: boolean; search: { datacenterId: string; customerId: string; type: string; endDate: Date | string; startDate: Date | string }; ticketDetails: Array<any> });

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getTicketDetails();
    };
    asyncFunc();
  }, []);

  const getTicketDetails = async (searchObj?: any) => {
    setState({ ...state, isLoading: true });
    let tempSearch = { ...state.search };
    if (searchObj) {
      tempSearch = { ...tempSearch, ...searchObj };
    }
    tempSearch.startDate = moment(tempSearch.startDate).format("YYYY-MM-DD");
    tempSearch.endDate = moment(tempSearch.endDate).format("YYYY-MM-DD");

    const result = await getCustomerTicketDetails(tempSearch);
    if (result && result.success) {
      setState({
        ...state,
        isLoading: false,
        ticketDetails: result.data,
        search: { ...tempSearch },
      });
    }
  };
  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.data?.type) {
      case "date":
        return (
          <span>
            {column.fieldName && item[column.fieldName]
              ? // !isNaN(new Date(item[column.fieldName]).valueOf())
              moment(item[column.fieldName]).format("DD-MM-YYYY HH:MM:ss")
              : ""}
          </span>
        );
      case "csm":
        return <Text style={{ fontWeight: 600 }}>{item.csm}</Text>;
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const downloadReport = async () => {
    const result = await getCustomerTicketDetailsExcel({ ...state.search });
    let xlsx = await result.blob();
    const pdfFile = await new Blob([xlsx], {
      type: "application/vnd.openxmlformats",
    });
    const pdfFileURL = await URL.createObjectURL(pdfFile);
    var a: any = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display:none";
    a.href = pdfFileURL;
    a.download = `${state.search.type}.xlsx`;
    a.click();
  };
  const onSearch = async (type?: string) => {
    await getTicketDetails(type ? { type } : undefined);
  };

  return (
    <React.Fragment>
      <Stack tokens={childrenGap}>
        <Stack.Item>
          <br />
          <Stack horizontal wrap tokens={childrenGap} horizontalAlign="end">
            <Stack.Item>
              <Stack tokens={childrenGap} horizontal horizontalAlign="start">
                {/* {url === "service-tickets" && ( */}
                {/* {["service-tickets", "complaints-and-other-requests"].includes(url) && ( */}
                {["access-permission-and-material-movement", "complaints-and-other-requests"].includes(url) && (
                  <Stack.Item>
                    <Dropdown
                      styles={{ root: { width: "180px" } }}
                      placeholder="Select Service Type"
                      // label={'Service Type'}
                      selectedKey={state.search.type}
                      options={url === "access-permission-and-material-movement" ? TYPE_DROPDOWN : COMPLAINT_TYPE_DROPDOWN}
                      // options={url === "service-tickets" ? TYPE_DROPDOWN : COMPLAINT_TYPE_DROPDOWN}
                      // onChange={(e, v: IDropdownOption | undefined) => {
                      //   if (v) {
                      //     setState({
                      //       ...state,
                      //       search: {
                      //         ...state.search,
                      //         type: v.key as string,
                      //       },
                      //     });

                      //   }
                      // }}
                      onChange={(e, v: IDropdownOption | undefined) => {
                        if (v) {
                          // setState({
                          //   ...state,
                          //   search: {
                          //     ...state.search,
                          //     type: v.key as string,
                          //   },
                          // });
                          onSearch(v.key as string);
                        }
                      }}
                    />
                  </Stack.Item>
                )}
                <Stack.Item>
                  <PrimaryButton
                    text="Download Report"
                    disabled={
                      state.isLoading === true ||
                      state.ticketDetails.length === 0
                    }
                    onClick={() => downloadReport()}
                    className="custom-primary-btn"
                  />
                </Stack.Item>
              </Stack>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          {state.ticketDetails.length > 0 ? (
            <Fabric>
              <ShimmeredDetailsList
                items={state.ticketDetails}
                onRenderItemColumn={_renderItemColumn as any}
                columns={getColumns(state.search.type as any)}
                onShouldVirtualize={() => false}
                enableShimmer={state.isLoading}
                compact={true}
                setKey="ticketCounts"
                layoutMode={DetailsListLayoutMode.justified}
                selectionMode={SelectionMode.none}
                listProps={shimmeredDetailsListProps}
                onRenderRow={_onRenderRow}
              />
            </Fabric>
          ) : (
            <NoDataTile title="No Tickets Generated" />
          )}
        </Stack.Item>
      </Stack>
    </React.Fragment>
  );
};

export default TicketDetails;

const getColumns = (
  type:
    | "access-permission"
    | "material-movement"
    // | "others"
    | "case-ticket"
    | "service-complaint"
    | "service-request"
    | "remote-hand-services"
) => {
  const columns: IColumn[] = [
    {
      key: "csm",
      name: "CMS",
      fieldName: "csm",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "ticketId",
      name: "Ticket Id",
      fieldName: "ticketId",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "contractId",
      name: "Contract Id",
      fieldName: "contractId",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "serviceId",
      name: "Service Id",
      fieldName: "serviceId",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "assignmentGroup",
      name: "Assignment Group",
      fieldName: "assignmentGroup",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "item",
      name: "Item",
      fieldName: "item",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "shortDesc",
      name: "Short Description",
      fieldName: "shortDesc",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "state",
      name: "State",
      fieldName: "state",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "stage",
      name: "Stage",
      fieldName: "stage",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "openedBy",
      name: "Opened By",
      fieldName: "openedBy",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "closedBy",
      name: "Closed By",
      fieldName: "closedBy",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "helpDeskExecutive",
      name: "HelpDesk Executive",
      fieldName: "helpDeskExecutive",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "helpDeskDescComment",
      name: "HelpDesk Description Comment",
      fieldName: "helpDeskDescComment",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "requestBy",
      name: "Requested By",
      fieldName: "requestBy",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "roles",
      name: "Roles",
      fieldName: "roles",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "email",
      name: "Emails",
      fieldName: "email",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "emailReceivedOn",
      name: "Email Received On",
      fieldName: "emailReceivedOn",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "hdTAT",
      name: "HD TAT",
      fieldName: "hdTAT",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "hdTATStatus",
      name: "HD TAT Status",
      fieldName: "hdTATStatus",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "remarks",
      name: "Remarks",
      fieldName: "remarks",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "class",
      name: "Class",
      fieldName: "class",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "websiteOrMobileApp",
      name: "Website / Mobile App",
      fieldName: "websiteOrMobileApp",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "initialTAT",
      name: "Initial TAT",
      fieldName: "initialTAT",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "initialTATStatus",
      name: "Initial TAT Status",
      fieldName: "initialTATStatus",
      minWidth: 200,
      maxWidth: 250,
      isResizable: true,
    },

    // validityFrom: Date;
    // validityTo: Date;
  ];
  switch (type) {
    case "access-permission": {
      columns.push({
        key: "requestType",
        name: "Request Type",
        fieldName: "requestType",
        minWidth: 200,
        maxWidth: 250,
        isResizable: true,
      });
      columns.push({
        key: "accessType",
        name: "Access Type",
        fieldName: "accessType",
        minWidth: 200,
        maxWidth: 250,
        isResizable: true,
      });
      columns.push({
        key: "validityFrom",
        name: "Entry Pass Validity(From)",
        fieldName: "validityFrom",
        minWidth: 200,
        maxWidth: 250,
        isResizable: true,
        data: {
          type: "date",
        },
      });
      columns.push({
        key: "validityTo",
        name: "Entry Pass Validity(To)",
        fieldName: "validityTo",
        minWidth: 200,
        maxWidth: 250,
        isResizable: true,
        data: {
          type: "date",
        },
      });
      break;
    }
    case "material-movement": {
      columns.push({
        key: "typeOfMaterialMovement",
        name: "Type of Material  Movement",
        fieldName: "typeOfMaterialMovement",
        minWidth: 200,
        maxWidth: 250,
        isResizable: true,
      });
      break;
    }
    // case "others": {
    //   columns.push({
    //     key: "category",
    //     name: "Select a Category",
    //     fieldName: "category",
    //     minWidth: 200,
    //     maxWidth: 250,
    //     isResizable: true,
    //   });
    //   columns.push({
    //     key: "mentionSelectedCatDetails",
    //     name: "Description(mention category details)",
    //     fieldName: "mentionSelectedCatDetails",
    //     minWidth: 200,
    //     maxWidth: 250,
    //     isResizable: true,
    //   });
    //   columns.push({
    //     key: "subCategory",
    //     name: "Sub Category",
    //     fieldName: "subCategory",
    //     minWidth: 200,
    //     maxWidth: 250,
    //     isResizable: true,
    //   });
    //   columns.push({
    //     key: "emailIdToBeAddedInCC",
    //     name:
    //       "Email-ID to be added  in Cc [Multiple Email-ID's should be seperated by semi-colon(;)",
    //     fieldName: "emailIdToBeAddedInCC",
    //     minWidth: 200,
    //     maxWidth: 250,
    //     isResizable: true,
    //   });
    //   columns.push({
    //     key: "emailSubjectLine",
    //     name: "Email Subject Line",
    //     fieldName: "emailSubjectLine",
    //     minWidth: 200,
    //     maxWidth: 250,
    //     isResizable: true,
    //   });
    //   columns.push({
    //     key: "dependency",
    //     name: "Dependency",
    //     fieldName: "dependency",
    //     minWidth: 200,
    //     maxWidth: 250,
    //     isResizable: true,
    //   });
    //   columns.push({
    //     key: "reasonForDependency",
    //     name: "Reason For Dependency",
    //     fieldName: "reasonForDependency",
    //     minWidth: 200,
    //     maxWidth: 250,
    //     isResizable: true,
    //   });
    //   columns.push({
    //     key: "auditScheduleDate",
    //     name: "Audit Schedule Date",
    //     fieldName: "auditScheduleDate",
    //     minWidth: 200,
    //     maxWidth: 250,
    //     isResizable: true,
    //     data: {
    //       type: "date",
    //     },
    //   });
    //   columns.push({
    //     key: "userUpdatedInSnow",
    //     name: "User Updated In SNOW",
    //     fieldName: "userUpdatedInSnow",
    //     minWidth: 200,
    //     maxWidth: 250,
    //     isResizable: true,
    //   });
    //   columns.push({
    //     key: "portalCredSharedWithCustomer",
    //     name: "Portal Credentials Shared With Customer",
    //     fieldName: "portalCredSharedWithCustomer",
    //     minWidth: 200,
    //     maxWidth: 250,
    //     isResizable: true,
    //   });
    //   columns.push({
    //     key: "customerNameAndEmailIDAdded",
    //     name: "Customer Name & Email ID Added",
    //     fieldName: "customerNameAndEmailIDAdded",
    //     minWidth: 200,
    //     maxWidth: 250,
    //     isResizable: true,
    //   });
    //   break;
    // }
    case "case-ticket":
    case "service-complaint":
    case "service-request":
      {
        columns.push({
          key: "number",
          name: "Number",
          fieldName: "number",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "contact",
          name: "Contact",
          fieldName: "contact",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "emailIdToBeAddedInCC",
          name: "Email-ID to be added in CC",
          fieldName: "emailIdToBeAddedInCC",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "category",
          name: "Category",
          fieldName: "category",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "subCategory",
          name: "Sub Category",
          fieldName: "subCategory",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "priority",
          name: "Priority",
          fieldName: "priority",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "assignedTo",
          name: "Assigned To",
          fieldName: "assignedTo",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "dependency",
          name: "Dependency",
          fieldName: "dependency",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "updated",
          name: "Updated",
          fieldName: "updated",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
          data: {
            type: "date",
          },
        });
        columns.push({
          key: "resolutionCode",
          name: "Resolution Code",
          fieldName: "resolutionCode",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "resolutionNotes",
          name: "Resolution Notes",
          fieldName: "resolutionNotes",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "resolved",
          name: "Resolved",
          fieldName: "resolved",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "resolvedBy",
          name: "Resolved By",
          fieldName: "resolvedBy",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        columns.push({
          key: "ageing",
          name: "Ageing",
          fieldName: "ageing",
          minWidth: 200,
          maxWidth: 250,
          isResizable: true,
        });
        break;
      }
    case "remote-hand-services": {
      // columns.push({
      //   key: "",
      //   name: "Customer Organization",
      //   fieldName: "",
      //   minWidth: 200,
      //   maxWidth: 250,
      //   isResizable: true,
      // });
      // columns.push({
      //   key: "",
      //   name: "Company Name",
      //   fieldName: "",
      //   minWidth: 200,
      //   maxWidth: 250,
      //   isResizable: true,
      // });
      // columns.push({
      //   key: "",
      //   name: "Registration Code/SAP Code",
      //   fieldName: "",
      //   minWidth: 200,
      //   maxWidth: 250,
      //   isResizable: true,
      // });
      // columns.push({
      //   key: "",
      //   name: "DC Location/Office",
      //   fieldName: "",
      //   minWidth: 200,
      //   maxWidth: 250,
      //   isResizable: true,
      // });
      columns.push({
        key: "requestBy",
        name: "Requested By",
        fieldName: "requestBy",
        minWidth: 200,
        maxWidth: 250,
        isResizable: true,
      });
      columns.push({
        key: "requestType",
        name: "Request Type",
        fieldName: "requestType",
        minWidth: 200,
        maxWidth: 250,
        isResizable: true,
      });
      columns.push({
        key: "selectActivityList",
        name: "Select Activity List",
        fieldName: "selectActivityList",
        minWidth: 200,
        maxWidth: 250,
        isResizable: true,
      });
      columns.push({
        key: "proposeSchedule",
        name: "Propose Schedule",
        fieldName: "proposeSchedule",
        minWidth: 200,
        maxWidth: 250,
        isResizable: true,
      });
      columns.push({
        key: "proposeStateDateTime",
        name: "Proposed State Date/Time",
        fieldName: "proposeStateDateTime",
        minWidth: 200,
        maxWidth: 250,
        isResizable: true,
      });
      columns.push({
        key: "proposeEndDateTime",
        name: "Proposed End Date/Time",
        fieldName: "proposeEndDateTime",
        minWidth: 200,
        maxWidth: 250,
        isResizable: true,
      });
      columns.push({
        key: "mentionSelectedActivityDetails",
        name: "Description(Mention Selected Activity Details)",
        fieldName: "mentionSelectedActivityDetails",
        minWidth: 200,
        maxWidth: 250,
        isResizable: true,
      });
      break;
    }
  }
  columns.push({
    key: "created",
    name: "Created",
    fieldName: "created",
    minWidth: 200,
    maxWidth: 250,
    isResizable: true,
    data: {
      type: "date",
    },
  });
  columns.push({
    key: "closed",
    name: "Closed",
    fieldName: "closed",
    minWidth: 200,
    maxWidth: 250,
    isResizable: true,
    data: {
      type: "date",
    },
  });
  return columns;
};
